module.exports = __webpack_public_path__ + "static/media/3.dac92f68.png";